import { PendingButton } from '../components/common/PendingButton';
import { CustomerPage } from './CustomerShell';
import { G } from './glyphs';

// INFO, PARKED (Freddi, 2026-10-09: "make the info tab as coming soon until we
// fully refine it"). The built page — Patricia's details, the handover
// windows, how to find us, how to pay, the household and its dogs — is
// `InfoPage.tsx`, kept whole and unrouted; the `customer-info` story carries
// it, with screenshots of how it stood, until it is refined. What a customer
// needs from this tab today and cannot get elsewhere is the way out, so Sign
// out stays.

export interface InfoSoonProps {
  contactName: string;
  email: string | null;
  onBook: () => void;
  onGo: (path: string) => void;
  onSignOut: () => Promise<void>;
}

export function InfoSoon({ contactName, email, onBook, onGo, onSignOut }: InfoSoonProps) {
  return (
    <CustomerPage on="info" contactName={contactName} onBook={onBook} onGo={onGo}>
      <h1 className="cp-h1">Info</h1>
      <div className="hs-foot">
        <div className="cp-card cp-dashed cp-soon">
          {G.info({ size: 22 })}
          <span className="cp-lead">Coming soon</span>
          <span className="cp-sub">Patricia’s details, how to find us, how to pay and your household will live here.</span>
        </div>
      </div>
      <p className="cp-eyebrow">Account</p>
      <div className="cp-card cp-account">
        {email && <span className="cp-sub cp-email">{email}</span>}
        <PendingButton className="cp-btn ghost" icon={G.signOut({ size: 15 })} onClick={onSignOut}>
          Sign out
        </PendingButton>
      </div>
    </CustomerPage>
  );
}
